import _objectWithoutProperties from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _defineProperty from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import { AuthContext } from './AuthContextProvider';
const secureRoutePropTypes = _objectSpread({}, Route.propTypes, {
  children: PropTypes.func,
  component: PropTypes.elementType,
  render: PropTypes.func
});
export const SecureRoute = _ref => {
  let children = _ref.children,
    Component = _ref.component,
    render = _ref.render,
    props = _objectWithoutProperties(_ref, ["children", "component", "render"]);
  const auth = useContext(AuthContext);
  if (auth && !auth.authenticated && !auth.isPending) {
    auth.login();
  }
  return React.createElement(Route, props, routeProps => {
    if (children) {
      return children(_objectSpread({}, routeProps, {
        auth
      }));
    }
    if (Component) {
      if (auth) {
        return (auth === null || auth === void 0 ? void 0 : auth.authenticated) && React.createElement(Component, routeProps);
      }
      return React.createElement(Component, routeProps);
    }
    if (render) {
      return render(_objectSpread({}, routeProps, {
        auth
      }));
    }
    return null;
  });
};
SecureRoute.propTypes = secureRoutePropTypes;
SecureRoute.displayName = 'SecureRoute';
SecureRoute.__docgenInfo = {
  componentName: "SecureRoute",
  packageName: "@jutro/auth",
  description: "Route which requires authentication\nInspired by Octa's SecureRoute\nhttps://github.com/okta/okta-oidc-js/blob/master/packages/okta-react/src/SecureRoute.js\nhttps://github.com/okta/okta-oidc-js/blob/8fe896a383fc5e02999d63068175e72bec538115/packages/okta-react/src/SecureRoute.js",
  displayName: "SecureRoute",
  methods: [],
  actualName: "SecureRoute",
  props: {
    children: {
      type: {
        name: "func"
      },
      required: false,
      description: "Functions called when rendering route. Takes precedence over component and render\n({ auth: Auth, ...routeProps }) => React.ReactNode"
    },
    component: {
      type: {
        name: "elementType"
      },
      required: false,
      description: "Component to be render when authenticated. Takes precedence over render"
    },
    render: {
      type: {
        name: "func"
      },
      required: false,
      description: "Functions called when rendering route\n({ auth: Auth, ...routeProps }) => React.ReactNode"
    }
  },
  composes: ["react-router-dom"]
};